export class PlantillaFilter {
   descripcion: string;
   tipoDteId: string;
   emisorId: string;
   tipoPapelId: number;
}
